import { useEffect, useState } from 'react';
import type { IdentifiedScaleResult } from '@core-api/presentation/types/response';
import type { ScalesChoice } from '../types';

interface useIdentifiedResultsListStateProps {
  choices: ScalesChoice[];
  identifiedResults: IdentifiedScaleResult[];
  shouldHideResults: boolean;
}

export interface IdentitiesListState {
  choiceId: number | null;
  value: number | null;
}

export const useIdentifiedResultsListState = ({
  choices,
  identifiedResults,
  shouldHideResults,
}: useIdentifiedResultsListStateProps) => {
  const [identitiesListState, setIdentitiesListState] =
    useState<IdentitiesListState>({
      choiceId: null,
      value: null,
    });

  useEffect(() => {
    if (shouldHideResults) {
      setIdentitiesListState({
        choiceId: null,
        value: null,
      });
    }
  }, [shouldHideResults, setIdentitiesListState]);

  const identitiesListChoiceId = identitiesListState.choiceId;
  const identityListChoice = choices.find(
    (c) => c.id === identitiesListChoiceId,
  );
  const identityListChoiceIndex = choices.findIndex(
    (c) => c.id === identitiesListChoiceId,
  );

  const activeScaleValueIdentities = identifiedResults
    ?.find((choice) => choice.choiceId === identitiesListState.choiceId)
    ?.scaleResults.find((result) => result.value === identitiesListState.value);

  return {
    identitiesListState,
    setIdentitiesListState,
    identityListChoice,
    identityListChoiceIndex,
    activeScaleValueIdentities,
  };
};
